import { Reactive_Key } from '../Constants';
export function reactive() {
    return (target, propertyKey, descriptor) => {
        const observers = Reflect.getMetadata(Reactive_Key, target) || [];
        if (observers.includes(propertyKey)) {
            console.warn(`Property ${propertyKey} is already defined as reactive!`);
            return target;
        }
        Object.defineProperty(target, propertyKey, {
            writable: true,
            value: target[propertyKey]
        });
        Reflect.defineMetadata(Reactive_Key, [...observers, propertyKey], target);
        return target;
    };
}
